import { FormControl, TextArea } from 'glic-ui-components';
const TextAreafield = ({ value, onTextChange, id, name, label, required, width, isDisabled, ariaLabelledby }) => {
    return (
        <div >
            {required == true ?
                <FormControl
                    isDisabled={false}
                    validations={value == '' ? {
                        required: { message: `${id} field is required.` },
                    } : ''}
                    validateOnChange
                    validateOnBlur
                >
                    <TextArea
                        id={id}
                        name={name}
                        label={label}
                        onChange={onTextChange}
                        isDisabled={isDisabled}
                        value={value}
                        aria-labelledby={ariaLabelledby}
                    />
                </FormControl>
                :
                <TextArea
                    id={id}
                    name={name}
                    label={label}
                    onChange={onTextChange}
                    isDisabled={isDisabled}
                    value={value}
                    aria-labelledby={ariaLabelledby}
                />
            }
        </div>
    )
}

export default TextAreafield
